import React, { useState } from "react";
function Shared100toGPA5() {
  const [originalPercentage, setOriginalPercentage] = useState("");
  const [convertedGPA, setConvertedGPA] = useState("");
  const [showResult, setShowResult] = useState(false);
  const [error, setError] = useState(null);
  const handleCalculateClick = () => {
    const percentage = parseFloat(originalPercentage);
    if (!isNaN(percentage) && percentage >= 60 && percentage <= 100) {
      let calculatedGPA = "";
      if (percentage >= 100) {
        calculatedGPA = "4.95 ~ 5.0";
      } else if (percentage >= 99) {
        calculatedGPA = "4.90 ~ 4.94";
      } else if (percentage >= 98) {
        calculatedGPA = "4.84 ~ 4.89";
      } else if (percentage >= 97) {
        calculatedGPA = "4.79 ~ 4.83";
      } else if (percentage >= 96) {
        calculatedGPA = "4.73 ~ 4.78";
      } else if (percentage >= 95) {
        calculatedGPA = "4.68 ~ 4.72";
      } else if (percentage >= 94) {
        calculatedGPA = "4.62 ~ 4.67";
      } else if (percentage >= 93) {
        calculatedGPA = "4.57 ~ 4.61";
      } else if (percentage >= 92) {
        calculatedGPA = "4.51 ~ 4.56";
      } else if (percentage >= 91) {
        calculatedGPA = "4.45 ~ 4.50";
      } else if (percentage >= 90) {
        calculatedGPA = "4.34 ~ 4.44";
      } else if (percentage >= 89) {
        calculatedGPA = "4.23 ~ 4.33";
      } else if (percentage >= 88) {
        calculatedGPA = "4.12 ~ 4.22";
      } else if (percentage >= 87) {
        calculatedGPA = "4.01 ~ 4.11";
      } else if (percentage >= 86) {
        calculatedGPA = "3.90 ~ 4.00";
      } else if (percentage >= 85) {
        calculatedGPA = "3.79 ~ 3.89";
      } else if (percentage >= 84) {
        calculatedGPA = "3.68 ~ 3.78";
      } else if (percentage >= 83) {
        calculatedGPA = "3.57 ~ 3.67";
      } else if (percentage >= 82) {
        calculatedGPA = "3.45 ~ 3.56";
      } else if (percentage >= 81) {
        calculatedGPA = "3.34 ~ 3.44";
      } else if (percentage >= 80) {
        calculatedGPA = "3.23 ~ 3.33";
      } else if (percentage >= 79) {
        calculatedGPA = "3.12 ~ 3.22";
      } else if (percentage >= 78) {
        calculatedGPA = "3.01 ~ 3.11";
      } else if (percentage >= 77) {
        calculatedGPA = "2.90 ~ 3.00";
      } else if (percentage >= 76) {
        calculatedGPA = "2.79 ~ 2.89";
      } else if (percentage >= 75) {
        calculatedGPA = "2.68 ~ 2.78";
      } else if (percentage >= 74) {
        calculatedGPA = "2.57 ~ 2.67";
      } else if (percentage >= 73) {
        calculatedGPA = "2.46 ~ 2.56";
      } else if (percentage >= 72) {
        calculatedGPA = "2.35 ~ 2.45";
      } else if (percentage >= 71) {
        calculatedGPA = "2.24 ~ 2.34";
      } else if (percentage >= 70) {
        calculatedGPA = "2.13 ~ 2.23";
      } else if (percentage >= 69) {
        calculatedGPA = "2.02 ~ 2.12";
      } else if (percentage >= 68) {
        calculatedGPA = "1.92 ~ 2.01";
      } else if (percentage >= 67) {
        calculatedGPA = "1.82 ~ 1.91";
      } else if (percentage >= 66) {
        calculatedGPA = "1.71 ~ 1.81";
      } else if (percentage >= 65) {
        calculatedGPA = "1.60 ~ 1.70";
      } else if (percentage >= 64) {
        calculatedGPA = "1.50 ~ 1.59";
      } else if (percentage >= 63) {
        calculatedGPA = "1.40 ~ 1.49";
      } else if (percentage >= 62) {
        calculatedGPA = "1.31 ~ 1.39";
      } else if (percentage >= 61) {
        calculatedGPA = "1.21 ~ 1.30";
      } else if (percentage >= 60) {
        calculatedGPA = "1.11 ~ 1.20";
      } else {
        calculatedGPA = "0.00 ~ 1.10 (Échec)";
      }
      setConvertedGPA(calculatedGPA);
      setShowResult(true);
      setError(null);
    } else {
      setError("Entrez un pourcentage valide entre 60 et 100");
      setShowResult(false);
    }
  };
  return (
    <div className="ltr">
      <div className="row">
        <div className="col-sm-12 col-md-7 calculatorStyle">
          <div className="p-3 mb-2 bg-success text-white">
            <h2 style={{ fontSize: "16px" }}>
              Convertir la note de 100 au GPA 5
            </h2>
          </div>
          <hr />
          <div className="form-group d-flex align-items-center">
            <b>
              <label htmlFor="originalPercentage">Pourcentage:</label>
            </b>
            <input
              type="text"
              value={originalPercentage}
              id="originalPercentage"
              onChange={(e) => setOriginalPercentage(e.target.value)}
              className="form-control"
              style={{ width: "200px", marginRight: "10px" }}
            />
          </div>
          <button
            className="btn btn-success mt-3"
            onClick={handleCalculateClick}
          >
                 Calculer
          </button>
          <br />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-sm-12 col-md-7">
          {error && (
            <div className="alert alert-warning">
              <b>
                <u> Erreur :</u>
              </b>{" "}
              {error}
            </div>
          )}
          {showResult && (
            <div
              style={{ fontSize: "17px" }}
              className=" bg-light bg-gradient text-dark"
            >
              <div className="p-3 bg-success bg-gradient text-white">
                <strong>Résultats:</strong>
              </div>
              <b>Plage GPA (5.0) :{convertedGPA}</b>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default Shared100toGPA5;
